{
  "add-files": "{count, plural, =1 {Add File} other {Add Files}}",
  "cancel": "Cancel",
  "clear": "Clear",
  "continue": "Continue",
  "copy": "Copy",
  "create": "Create",
  "delete": "Delete",
  "remove": "Remove",
  "download_csv": "Download CSV",
  "edit": "Edit",
  "enable": "Enable",
  "hide": "Hide",
  "more_actions": "More actions",
  "next": "Next",
  "override": "Override",
  "previous": "Previous",
  "read_guide": "Read the guide",
  "reload": "Reload",
  "reset": "Reset",
  "save": "Save",
  "show": "Show",
  "speak_to_team": "Speak to our team",
  "upgrade": "Upgrade",
  "upload": "Upload",
  "view": "View",
  "view_dashboard": "View dashboard",
  "columns": "Columns",
  "manage": "Manage",
  "whats_new": "What's new",
  "go_to_dashboard": "Go to dashboard"
}
